// extracted by mini-css-extract-plugin
module.exports = {"settings":"settings_settings__d6LWA","settingsTitle":"settings_settingsTitle__13CuG","buttonRow":"settings_buttonRow__1aw0u","settingsFooter":"settings_settingsFooter__3crjI"};